import axios from "axios";
import {
  resolveNcrmNotificationRoute,
  selectNewUnseenNotifications,
} from "@/Utile/ncrmNotifications.mjs";

export default {
  data() {
    return {
      unseenCount: 0,
      summaryTimer: null,
      summaryInitialized: false,
      latestUnseenId: null,
      loadingLiveItems: false,
      liveQueue: [],
      liveAlert: null,
      liveToastOpen: false,
    };
  },
  beforeUnmount() {
    this.stopSummaryPolling();
  },
  methods: {
    async fetchSummary() {
      if (!this.enabled) return;
      try {
        const { data } = await axios.get("/ncrm/notifications/summary");
        const nextLatestUnseenId = Number(data?.latestUnseenId) > 0
          ? Number(data.latestUnseenId)
          : null;
        const previousLatestUnseenId = this.latestUnseenId;
        this.unseenCount = Number(data?.unseenCount || 0);
        this.$emit("summary", {
          unseenCount: this.unseenCount,
          total: Number(data?.total || 0),
        });
        if (
          this.summaryInitialized &&
          !this.modelValue &&
          nextLatestUnseenId &&
          nextLatestUnseenId > Number(previousLatestUnseenId || 0)
        ) {
          await this.loadLiveItems(Number(previousLatestUnseenId || 0));
        }
        this.latestUnseenId = nextLatestUnseenId;
        this.summaryInitialized = true;
      } catch {
        this.unseenCount = 0;
        this.$emit("summary", { unseenCount: 0, total: 0 });
      }
    },
    startSummaryPolling() {
      this.stopSummaryPolling();
      this.fetchSummary();
      this.summaryTimer = setInterval(() => this.fetchSummary(), 15 * 1000);
    },
    stopSummaryPolling() {
      if (this.summaryTimer) clearInterval(this.summaryTimer);
      this.summaryTimer = null;
    },
    async loadLiveItems(afterId) {
      if (this.loadingLiveItems) return;
      this.loadingLiveItems = true;
      try {
        const { data } = await axios.get("/ncrm/notifications", { params: { limit: 10 } });
        const queuedIds = new Set([
          this.liveAlert?.id,
          ...this.liveQueue.map((item) => item.id),
        ]);
        const freshItems = selectNewUnseenNotifications(data?.items, {
          afterId,
          excludeIds: [...queuedIds],
          limit: 3,
        });
        this.liveQueue.push(...freshItems);
        this.showNextLiveAlert();
      } catch {
        // Polling-ul următor reîncearcă sumarul; centrul rămâne sursa de adevăr.
      } finally {
        this.loadingLiveItems = false;
      }
    },
    showNextLiveAlert() {
      if (this.liveAlert || !this.liveQueue.length || this.modelValue) return;
      this.liveAlert = this.liveQueue.shift();
      this.liveToastOpen = true;
    },
    onLiveToastVisibility(value) {
      this.liveToastOpen = value;
      if (value) return;
      this.liveAlert = null;
      this.$nextTick(() => this.showNextLiveAlert());
    },
    clearLiveAlerts() {
      this.liveToastOpen = false;
      this.liveAlert = null;
      this.liveQueue = [];
    },
    async openLiveNotification(item) {
      if (!item?.id) return;
      const route = resolveNcrmNotificationRoute(item);
      this.clearLiveAlerts();
      try {
        await axios.post("/ncrm/notifications/seen", {
          notificationIds: [item.id],
          timezoneOffsetMinutes: new Date().getTimezoneOffset(),
        });
      } catch {
        // Navigarea rămâne disponibilă; badge-ul va reflecta starea reală la următorul polling.
      } finally {
        await this.fetchSummary();
        if (route) this.$router.push(route);
      }
    },
  },
};
